import { useEffect, useState } from "react";
import { api } from "./api";
import { useContext } from "react";
import MessageContext from "components/message/message";

export const useDialog = () => {
  const [dialogState, setDialogState] = useState(false);

  const handleOpen = () => setDialogState(true);
  const handleClose = () => setDialogState(false);

  return [dialogState, handleOpen, handleClose];
};

export const useApi = (axiosParams) => {
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(false);

  const fetchData = async (params, showLoading = true) => {
    if (showLoading) setLoading(true);
    try {
      const response = await api.request(params);
      setData(response.data);
    } catch (e) {
    } finally {
      if (showLoading) setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(axiosParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    data,
    loading,
    setData,
    setLoading,
    refetch: (data, showLoading) => fetchData(data || axiosParams, showLoading),
  };
};

export const useMessage = () => useContext(MessageContext);
